<div class="pricing-box">
  <div class="pricing-header">
    <h3>{{ product.name }}</h3>
    <p>{{ productDescription }}</p>
  </div>
  <div class="price">
    <div>
      <small
        class="text-muted"
        i18n="@@pricingFromLabel"
        *ngIf="product.metadata.position !== '0'"
        style="font-size: 12px"
        >from</small
      >
      {{ product.prices[0].currency }}
      <ng-container *ngIf="product.prices[0].unit_amount === null">
        {{ product.prices[0].tiers[0].flat_amount / 100 }}
      </ng-container>
      <ng-container *ngIf="product.prices[0].unit_amount !== null">
        {{ product.prices[0].unit_amount / 100 }}
      </ng-container>
    </div>

    <span>/ {{ interval }}</span>
  </div>
  <div class="buy-btn">
    <a [href]="urlSignUp" target="_blank" class="btn btn-primary" i18n="@@getStartedButton">Get started</a>
  </div>
  <ul class="pricing-features">
    <li><i-feather name="check"></i-feather> {{ productKeyData }}</li>
    <li><i-feather name="check"></i-feather> {{ productKeyData1 }}</li>
    <li><i-feather name="check"></i-feather> {{ productKeyData2 }}</li>
    <li><i-feather name="check"></i-feather> {{ productKeyData3 }}</li>
    <li *ngIf="productKeyData4 !== ''"><i-feather name="check"></i-feather> {{ productKeyData4 }}</li>
  </ul>
  <div class="mb-0">
    <p style="font-size: 10px">{{ productNote }}</p>
  </div>
</div>
